import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ru from './resources/ru.json';
import en from './resources/en.json';
import pl from './resources/pl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      pl: { translation: pl },
    },
    fallbackLng: 'ru-RU',
    interpolation: {
      escapeValue: false,
    },
  });
